import LegalDocument from './legal/LegalDocument'
import privacy from './legal/content/ovacsPrivacy'

/**
 * Public Privacy Policy, rendered as HTML so Google's OAuth verifier can
 * crawl it. Keep this URL stable: the Google consent screen links to it.
 *
 * URL: https://ovacs.com/privacy
 */
const PrivacyPolicyPage = () => (
  <LegalDocument
    doc={privacy}
    description="OVACS Privacy Policy: how Stirring Apps FZE LLC collects, uses, shares and protects personal data in OVACS."
  />
)

export default PrivacyPolicyPage
